import { useEffect, useState } from 'react';
import type { CopyToOrganizationModalProps } from './types';

export function CopyToOrganizationModal({
  open,
  completedCount,
  defaultProjectName,
  onClose,
  onCopy,
}: CopyToOrganizationModalProps) {
  const [organizationId, setOrganizationId] = useState('');
  const [projectName, setProjectName] = useState('');

  const parsedOrganizationId = Number(organizationId.trim());
  const canCopy =
    Number.isInteger(parsedOrganizationId) &&
    parsedOrganizationId > 0 &&
    completedCount > 0;

  const handleCopy = () => {
    if (!canCopy) return;
    onCopy(parsedOrganizationId, projectName.trim() || defaultProjectName);
  };

  useEffect(() => {
    if (!open) return;
    setOrganizationId('');
    setProjectName('');
  }, [open]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="syntax-modal" onClick={(event) => event.stopPropagation()}>
        <div className="syntax-header">
          <div>
            <h3>
              Copy to another organization{' '}
              <span className="ann-stat-badge ann-stat-inprogress">BETA</span>
            </h3>
            <div className="syntax-subtitle">
              Not fully implemented, will be redefined later.
              Copies floor plans, diagrams and takeoff data into a <strong>new project</strong> in
              the target organization.
              Does <strong>not</strong> create an agent-side project — nothing will appear in this
              annotation tab.
              Does <strong>not</strong> copy upload/file rows or per-user marker states.
            </div>
          </div>
          <button className="ann-detail-close" onClick={onClose}>&times;</button>
        </div>
        <div className="syntax-body">
          <label className="org-copy-field">
            <span>Organization ID</span>
            <input
              type="number"
              min="1"
              value={organizationId}
              placeholder="e.g. 32"
              onChange={(event) => setOrganizationId(event.target.value)}
            />
          </label>
          <label className="org-copy-field">
            <span>Project name</span>
            <input
              type="text"
              value={projectName}
              placeholder={defaultProjectName}
              onChange={(event) => setProjectName(event.target.value)}
            />
          </label>
          <div className="text-dim">
            {completedCount > 0
              ? `${completedCount} completed plan${completedCount !== 1 ? 's' : ''} will be copied.`
              : 'No completed plans to copy.'}
          </div>
        </div>
        <div className="syntax-footer">
          <button className="btn-review-action" onClick={onClose}>Cancel</button>
          <button
            className="btn-review-action btn-publish"
            disabled={!canCopy}
            onClick={handleCopy}
          >
            Copy to organization
          </button>
        </div>
      </div>
    </div>
  );
}
